/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

// import { CubeTextureLoader } from 'three';
import React from 'react';
import { useLoader } from 'react-three-fiber';
import { GLTFLoader, GLTF } from 'three/examples/jsm/loaders/GLTFLoader';
import { Color } from 'three';

type Props = {
  isSelected: boolean;
}

type GLTFResult = GLTF & {
  nodes: {
    Totem: THREE.Mesh
  }
  materials: {
    Totem: THREE.MeshStandardMaterial
  }
}
export default React.forwardRef(function Model(props: Props & JSX.IntrinsicElements['group'], ref: any) {
  const { nodes, materials } = useLoader<GLTFResult>(GLTFLoader, 'assets/Totem/Totem.gltf');

  // // Load CubeTexture for env map
  // const cubeTexture = useLoader(CubeTextureLoader, [[
  //   'assets/envmap/px.jpg',
  //   'assets/envmap/nx.jpg',
  //   'assets/envmap/py.jpg',
  //   'assets/envmap/ny.jpg',
  //   'assets/envmap/pz.jpg',
  //   'assets/envmap/nz.jpg'
  // ]]);

  // // Set env map for each material
  // Object.values(materials).forEach((material) => {
  //   material.envMap = cubeTexture[0];
  // });

  if (props.isSelected) {
    materials.Totem.opacity = 0.85;
    materials.Totem.color = new Color(0.807, 0.37, 0.136);
  } else {
    materials.Totem.opacity = 1;
    materials.Totem.color = new Color(1, 1, 1);
  }

  return (
    <group name="Totem" {...props} scale={[2, 2, 2]} dispose={null}>
      <mesh ref={ref} castShadow material={materials.Totem} geometry={nodes.Totem.geometry} />
    </group>
  )
})
